import type { TermsTranslations } from '~/locales/en-US/terms.translations';

const translations: TermsTranslations = {
  title: 'Kullanım Koşulları',
  lastUpdated: 'Son Güncelleme: 7 Mart 2024',
  sections: {
    introduction: {
      title: 'Giriş',
      content:
        "BiteCritic'e hoş geldiniz! Bu Kullanım Koşulları, platformumuzun ve hizmetlerimizin kullanımını düzenler. BiteCritic'i kullanarak bu koşulları tamamen kabul etmiş olursunuz.",
    },
    userAgreement: {
      title: 'Kullanıcı Sözleşmesi',
      content:
        "BiteCritic'te hesap oluşturarak aşağıdakileri kabul etmiş olursunuz:",
      items: [
        'Doğru ve gerçek bilgiler sağlamayı',
        'Hesabınızın güvenliğini korumayı',
        'Hesabınız altındaki tüm aktivitelerin sorumluluğunu üstlenmeyi',
        'Tüm geçerli yasa ve yönetmeliklere uymayı',
      ],
    },
    content: {
      title: 'İçerik Kuralları',
      content: "BiteCritic'i kullanırken aşağıdakileri kabul edersiniz:",
      items: [
        'Gerçek ve dürüst değerlendirmeler paylaşmayı',
        'Fikri mülkiyet haklarına saygı göstermeyi',
        'Zararlı, saldırgan veya uygunsuz içerik paylaşmamayı',
        'Spam veya yanıltıcı davranışlarda bulunmamayı',
      ],
    },
    contentRights: {
      title: 'İçerik Hakları ve Saklama',
      content: "BiteCritic'teki içeriğinizle ilgili olarak:",
      items: [
        'İçeriğinizin mülkiyetini elinizde tutarsınız, ancak Hizmet ile bağlantılı olarak ve BiteCritic\'in tanıtım ve pazarlama amaçları için içeriğinizi kullanmak, görüntülemek, dağıtmak, çoğaltmak, değiştirmek ve türev çalışmalar oluşturmak üzere dünya çapında, münhasır olmayan, telifsiz bir lisans verirsiniz; bu, web sitemizde, uygulamamızda ve sosyal medya gibi üçüncü taraf platformlarda görüntüleme ile sınırlı olmaksızın içeriğinizin kullanımını kapsar',
        'Hesabınızı sildiğinizde, kişisel bilgileriniz anonimleştirilecek, ancak değerlendirmeleriniz ve diğer katkıda bulunduğunuz içerikler saklanabilir',
        'Hesap silindikten sonra içerik "Anonim Kullanıcı" tarafından gönderilmiş olarak görünecektir',
        'Tüm içeriğin tamamen silinmesi için hurricanesoftwaresolutions@gmail.com adresinden doğrudan bizimle iletişime geçmelisiniz',
        'Platformun tüm kullanıcılar için değerini korumak amacıyla anonimleştirilmiş değerlendirmeleri göstermeye devam edebiliriz',
      ],
    },
    privacy: {
      title: 'Gizlilik ve Veri',
      content:
        "Gizliliğinizi ciddiye alıyoruz. BiteCritic'i kullanarak aşağıdakileri kabul etmiş olursunuz:",
      items: [
        'Verilerinizi Gizlilik Politikamızda belirtildiği şekilde topladığımızı ve işlediğimizi',
        'Herkese açık profilinizin ve değerlendirmelerinizin diğer kullanıcılar tarafından görülebileceğini',
        'Gizlilik ayarlarınızı hesabınız üzerinden kontrol edebileceğinizi',
        'Çerezler ve benzer teknolojiler kullandığımızı',
      ],
    },
    community: {
      title: 'Topluluk Kuralları',
      content:
        'BiteCritic topluluğunun bir üyesi olarak aşağıdakileri kabul edersiniz:',
      items: [
        'Diğer kullanıcılara saygılı davranmayı',
        'Başkalarına karşı taciz veya ayrımcılık yapmamayı',
        'Yapıcı ve yardımcı katkılarda bulunmayı',
        'Uygunsuz içerik veya davranışları bildirmeyi',
      ],
    },
    termination: {
      title: 'Hesap Sonlandırma',
      content: 'Aşağıdaki hakları saklı tutarız:',
      items: [
        'Bu koşulları ihlal eden hesapları askıya almak veya sonlandırmak',
        'Kurallarımızı ihlal eden içerikleri kaldırmak',
        'Makul bir bildirimle hizmetleri değiştirmek veya sonlandırmak',
        'Hesap silme işleminde kullanıcı verilerini anonimleştirmek ancak içeriği saklamak',
        'E-posta yoluyla gelen tam silme taleplerini 30 gün içinde işleme almak',
      ],
    },
  },
  agreement: {
    checkbox: 'Kullanım Koşullarını okudum ve kabul ediyorum',
    required: 'Devam etmek için Kullanım Koşullarını kabul etmelisiniz',
    view: 'Kullanım Koşullarını Görüntüle',
  },
};

export default translations;
